export const mediaSizes = {
  xxl: 1580,
  xx: 1366,
  xl: 1200,
  x: 1024,
  lg: 992,
  m: 768,
  sm: 575,
};
